import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { axios } from 'api'
import { Box, Flex, Image, SVGImage, H3, H6 } from 'ui/bend'
import { Locked } from 'images'

import { unlock_membership_event } from 'gtm/pushEvents'

const LockedImage = styled(Image)`
  filter: brightness(50%);
  width: 100%;
`

const VideoPlayerLocked = ({ videoId }) => {
  const [thumbnail, setThumbnail] = useState()

  useEffect(() => {
    const fetchThumbnail = async () => {
      try {
        const res = await axios.get(`videos/${videoId}/thumbnail`)
        if (res && res.data && res.data.thumbnail) {
          setThumbnail(res.data.thumbnail)
        }
      } catch (e) {
        // TODO: feedfm - There is no thumbnail or it didn't response properly. What do here?
      }
    }

    fetchThumbnail()
  }, [])

  return (
    <Box position='relative'>
      {thumbnail && <LockedImage src={thumbnail} alt='Video Cover Photo' />}
      <Flex
        position='absolute'
        top='0'
        left='0'
        width='100%'
        height='100%'
        zIndex='1'
        justifyContent='center'
        alignItems='center'
        as='a'
        className='unstyled'
        cursor='pointer'
        href='/surveys/onboarding'
        onClick={() => unlock_membership_event('video')}
      >
        <SVGImage SVG={Locked} fill='white' height='60px' width='60px' />
        <Flex
          flexDirection='column'
          justifyContent='space-between'
          ml={['15px', null, '20px']}
        >
          <H3 color='white' as='div'>
            Unlock this class
          </H3>
          <H6 color='white' as='div'>
            Start Your Free Trial Today
          </H6>
        </Flex>
      </Flex>
    </Box>
  )
}

VideoPlayerLocked.propTypes = {
  videoId: PropTypes.number.isRequired
}

export default VideoPlayerLocked
